import React from 'react'
import { FooterWow } from '@shared/components/footer'
import { PageLayout } from '@shared/components/page-layout'
import { PageLayoutOwnProps } from '@shared/components/page-layout/model'
import { Empty } from '@shared/models'
import { NextPageFC } from '@shared/models/next-fc'
import { PagesPath, pagesTitles } from 'data/pages-titles'

import { VseBudetHorosho } from '../screens/vse-budet-horosho'

const WowPage: NextPageFC<Empty, PageLayoutOwnProps> = () => VseBudetHorosho()

WowPage.layout = PageLayout

WowPage.layoutProps = {
	menuProps: {
		hideLinksList: true,
	},
	customFooter: <FooterWow extraContent={['']} />,
}

WowPage.headProps = {
	canonicalLink: 'https://credit.club/personal/na-refinansirovanie',
	title: pagesTitles[PagesPath.vseBudetHorosho].title,
	description:
		'От 200 тысяч рублей ► Конкурентная ставка ► До 2 млн в день обращения ► Без скрытых комиссий и платежей',
	ogImageName: 'wow.jpg',
}

export default WowPage
